import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "./Reveal";
import { ENGAGEMENT_MODELS } from "../data/content";

export const EngagementModels = () => (
  <section id="engagement" className="relative border-y hairline bg-card/30 py-24 sm:py-32" data-testid="engagement-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <SectionHeading
        index="10"
        eyebrow="Engagement"
        title="Flexible ways to work together."
        sub="Choose the structure that fits your team, timeline and ambition."
      />
      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {ENGAGEMENT_MODELS.map((m, i) => {
          const Icon = m.icon;
          return (
            <motion.a
              key={m.title}
              href="#contact"
              data-testid={`engagement-card-${i + 1}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -6 }}
              className="group flex flex-col rounded-2xl border hairline bg-card/60 p-7 transition-[border-color,box-shadow] duration-200 hover:border-primary/40 hover:shadow-[0_8px_40px_var(--green-glow)]"
            >
              <div className="flex items-center justify-between">
                <div className="rounded-xl border hairline bg-background/70 p-3 text-primary transition-transform duration-300 group-hover:scale-110">
                  <Icon className="h-5 w-5" />
                </div>
                <ArrowUpRight className="h-4 w-4 text-muted-foreground opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-hover:text-primary" />
              </div>
              <h3 className="mt-6 font-display text-base font-bold tracking-tight">{m.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{m.desc}</p>
            </motion.a>
          );
        })}
      </div>
    </div>
  </section>
);
